// Le mot court qui dit, dans une cellule de liste, pourquoi la configuration d'un compte ne s'affiche pas.
//
// ⚠️ UN « — » NE SUFFIT PAS : il se lit « rien à montrer », alors qu'il cache trois causes qui demandent trois gestes
// (poser la clé du déploiement, enregistrer des identifiants, les réenregistrer). La phrase complète vient du
// serveur, qui seul sait laquelle ; la liste en montre le mot, et la phrase en infobulle.
import type { ConfigIssue } from './api';

const SHORT: Record<ConfigIssue['kind'], string> = {
  no_key: 'clé absente',
  no_secret: 'non configuré',
  unreadable: 'illisible',
};

/** Le mot court d'une cause, ou `null` quand la configuration est lisible. */
export function configIssueShort(issue: ConfigIssue | null | undefined): string | null {
  return issue ? SHORT[issue.kind] : null;
}
